import "uikit/dist/js/uikit.min.js";
import Swiper from "swiper";
import {
	Autoplay,
	Navigation,
	EffectFade,
	Keyboard,
	Thumbs,
	FreeMode,
} from "swiper/modules";

// jQuery-specifc code
jQuery(function ($) {
	// Menu Dropdowns
	var svgOpen =
		'<div class="dropdown-trigger position-absolute end-0 translate-middle-y text-center lh-1"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24"><path fill="none" stroke="#ffffff" stroke-width="12" stroke-linecap="round" stroke-linejoin="round" d="M128 192l128 128 128-128"/></svg></div>';
	$("#main-nav .menu-item.dropdown").each(function () {
		// Appends the dropdown arrow
		$(this).append(svgOpen);
	});
	$("#main-nav .menu-item .dropdown-trigger").click(function () {
		// Toggles the dropdown
		$(this).siblings(".dropdown-menu").toggleClass("show");
	});
	// If #main-nav a.menu-item link is "#", open the dropdown instead of going to "#"
	$("#main-nav .menu-item a.nav-link").click(function (e) {
		if ($(this).attr("href") === "#") {
			e.preventDefault();
			$(this).siblings(".dropdown-menu").toggleClass("show");
		}
	});

	// Find each .inductees-carousel-swiper and initiate Swiper
	if ($(".inductees-carousel-swiper").length) {
		$(".inductees-carousel-swiper").each(function () {
			const $container = $(this).closest(".swiper-container");
			const swiper = new Swiper(this, {
				loop: true,
				speed: 600,
				slidesPerView: 4,
				spaceBetween: 16,
				modules: [Navigation, Keyboard],
				navigation: {
					nextEl: $container.find(".inductees-button-next")[0],
					prevEl: $container.find(".inductees-button-prev")[0],
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				breakpoints: {
					0: {
						slidesPerView: 1,
					},
					576: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 3,
					},
					992: {
						slidesPerView: 4,
					},
				},
			});

			// Ensure proper sizing after images load
			imagesLoaded($(this)[0], function () {
				swiper.update();
			});
		});
	}

	// Explorer category selected counts
	if ($("#explorer-filter").length) {
		var updateExplorerSelectedCounts = function () {
			var communitySelected = $(
				"#communityAccordion input.form-check-input[type='checkbox']:checked",
			).length;
			var sportsSelected = $(
				"#sportsAccordion input.form-check-input[type='checkbox']:checked",
			).length;

			$("#communitySelected").text(communitySelected);
			$("#sportsSelected").text(sportsSelected);
		};

		$(
			"#communityAccordion input.form-check-input[type='checkbox'], #sportsAccordion input.form-check-input[type='checkbox']",
		).on("change", updateExplorerSelectedCounts);

		$("#explorer-filter").on("reset", function () {
			setTimeout(function () {
				updateExplorerSelectedCounts();

				var communityCollapseEl = document.getElementById(
					"collapseCommunityFilters",
				);
				var sportsCollapseEl = document.getElementById("collapseSportsFilters");

				if (window.bootstrap && window.bootstrap.Collapse) {
					if (communityCollapseEl) {
						window.bootstrap.Collapse.getOrCreateInstance(communityCollapseEl, {
							toggle: false,
						}).hide();
					}
					if (sportsCollapseEl) {
						window.bootstrap.Collapse.getOrCreateInstance(sportsCollapseEl, {
							toggle: false,
						}).hide();
					}
				} else {
					$("#collapseCommunityFilters, #collapseSportsFilters").removeClass(
						"show",
					);
					$(
						"[data-bs-target='#collapseCommunityFilters'], [data-bs-target='#collapseSportsFilters']",
					)
						.addClass("collapsed")
						.attr("aria-expanded", "false");
				}

				$("#explorer .alpha-list a[data-alpha]").removeClass("active");
				$("#explorer .alpha-list a[data-alpha='']").addClass("active");
				loadExplorerResults(getExplorerFormData(1));
			}, 0);
		});

		updateExplorerSelectedCounts();

		var getExplorerFormData = function (paged) {
			return {
				name_filter: $("input[name='name_filter']", "#explorer-filter").val(),
				birthplace_filter: $(
					"input[name='birthplace_filter']",
					"#explorer-filter",
				).val(),
				born_in: $("select[name='born_in']", "#explorer-filter").val(),
				year_induction: $(
					"select[name='year_induction']",
					"#explorer-filter",
				).val(),
				main_category_filter: $(
					"input[name='main_category_filter']:checked",
					"#explorer-filter",
				).val(),
				identity_filter: $(
					"input[name='identity_filter']:checked",
					"#explorer-filter",
				)
					.map(function () {
						return $(this).val();
					})
					.get(),
				community_filter: $(
					"input[name='community_filter[]']:checked",
					"#explorer-filter",
				)
					.map(function () {
						return $(this).val();
					})
					.get(),
				sport_filter: $(
					"input[name='sport_filter[]']:checked",
					"#explorer-filter",
				)
					.map(function () {
						return $(this).val();
					})
					.get(),
				alpha_filter: $("input[name='alpha_filter']", "#explorer-filter").val(),
				paged: paged || 1,
			};
		};

		var getExplorerPageFromLink = function (href) {
			if (!href) {
				return null;
			}

			var pagedMatch = href.match(/[?&]paged=(\d+)/);
			if (pagedMatch && pagedMatch[1]) {
				return parseInt(pagedMatch[1], 10);
			}

			var pagePathMatch = href.match(/\/page\/(\d+)\/?/);
			if (pagePathMatch && pagePathMatch[1]) {
				return parseInt(pagePathMatch[1], 10);
			}

			var firstPageMatch = href.match(/#explorer$/);
			if (firstPageMatch) {
				return 1;
			}

			return null;
		};

		// Explorer filter AJAX
		var loadExplorerResults = function (formData) {
			if (!window.wrhofExplorerConfig) return;

			$("#explorer-filter")
				.find("button[type='submit']")
				.prop("disabled", true);

			var spinnerHtml =
				'<div id="explorer" class="explorer-results d-flex justify-content-center align-items-center" style="min-height: 400px;">' +
				'<div class="spinner-grow text-primary" role="status">' +
				'<span class="visually-hidden">Loading...</span>' +
				"</div>" +
				"</div>";

			$("#explorer").replaceWith(spinnerHtml);
			$("html, body").animate(
				{ scrollTop: $("#explorer").offset().top - 100 },
				300,
			);

			$.ajax({
				url: window.wrhofExplorerConfig.ajaxUrl,
				type: "POST",
				data: $.extend(
					{
						action: "wrhof_explorer_filter",
						nonce: window.wrhofExplorerConfig.nonce,
						page_url: window.wrhofExplorerConfig.pageUrl,
					},
					formData,
				),
				success: function (response) {
					if (response.success && response.data.html) {
						$("#explorer").replaceWith(response.data.html);
					}
				},
				error: function () {
					alert("An error occurred while loading results. Please try again.");
				},
				complete: function () {
					$("#explorer-filter")
						.find("button[type='submit']")
						.prop("disabled", false);
				},
			});
		};

		$("#explorer-filter").on("submit", function (e) {
			e.preventDefault();

			loadExplorerResults(getExplorerFormData(1));
		});

		$("#explorer-filter").on(
			"change",
			"select[name='born_in'], select[name='year_induction'], input[name='main_category_filter'], input[name='identity_filter'], input[name='community_filter[]'], input[name='sport_filter[]']",
			function () {
				loadExplorerResults(getExplorerFormData(1));
			},
		);

		$(document).on(
			"click",
			"#explorer .alpha-list a[data-alpha]",
			function (e) {
				e.preventDefault();

				var alphaValue = $(this).data("alpha");
				if (typeof alphaValue === "undefined") {
					alphaValue = "";
				}

				$("#explorer .alpha-list a[data-alpha]").removeClass("active");
				$(this).addClass("active");

				$("input[name='alpha_filter']", "#explorer-filter").val(alphaValue);
				loadExplorerResults(getExplorerFormData(1));
			},
		);

		$(document).on("click", "#explorer .pagination-container a", function (e) {
			e.preventDefault();

			var linkEl = $(this);
			var pagedValue = getExplorerPageFromLink(linkEl.attr("href"));

			if (!pagedValue) {
				var linkTextPage = parseInt(linkEl.text().trim(), 10);
				if (!isNaN(linkTextPage)) {
					pagedValue = linkTextPage;
				}
			}

			if (pagedValue) {
				loadExplorerResults(getExplorerFormData(pagedValue));
			}
		});
	}

	// Scrollspy classes
	$(".slide-in-bottom-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-medium; delay: 100",
	);
	$(".slide-in-left-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-medium; delay: 100",
	);
	$(".slide-in-right-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-medium; delay: 100",
	);
	$(".slide-in-bottom-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-small; delay: 100",
	);
	$(".slide-in-left-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-small; delay: 100",
	);
	$(".slide-in-right-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-small; delay: 100",
	);
	$(".fade-in").attr("uk-scrollspy", "cls: uk-animation-fade; delay: 100");
	$(".fade-in-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-fade; delay: 100",
	);
	$(".slide-in-bottom-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-small; delay: 100",
	);
	$(".slide-in-bottom-md-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-medium; delay: 100",
	);
	$(".slide-in-left-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-left-small; delay: 100",
	);

	// toTopButton
	if ($("#toTopButton").length) {
		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 600) {
				$("#toTopButton").removeClass("hidden");
			} else {
				$("#toTopButton").addClass("hidden");
			}
		});
		// Smoothly scroll back to top when the button is clicked
		$("#toTopButton").on("click", function (event) {
			event.preventDefault();
			window.scrollTo({ top: 0, behavior: "smooth" });
		});
	}
});
